import * as React from 'react';
import { UIHeading5 } from '@cian/ui-kit';
import { RATING_TEXT_MAP } from '../../constants/rating';
import { EStarSize } from '../../types/star';
import { getPrettyFloat } from '../../utils';
import { Stars } from '../Stars';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DesktopRatingComponent(_ref) {
  var value = _ref.value,
    reviewCount = _ref.reviewCount,
    withRatingValue = _ref.withRatingValue,
    _ref$ratingText = _ref.ratingText,
    ratingText = _ref$ratingText === void 0 ? RATING_TEXT_MAP[Math.floor(value)] : _ref$ratingText;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [!!value && /*#__PURE__*/_jsx("div", {
      "data-testid": "rating",
      className: styles['rating'],
      itemProp: withRatingValue ? 'ratingValue' : undefined,
      children: getPrettyFloat(value)
    }), reviewCount !== undefined && /*#__PURE__*/_jsx("span", {
      "data-testid": "reviewCount",
      itemProp: "reviewCount",
      className: styles['invisible'],
      children: reviewCount
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['details'],
      children: [/*#__PURE__*/_jsx(Stars, {
        value: value,
        size: EStarSize.S
      }), /*#__PURE__*/_jsx(UIHeading5, {
        children: ratingText
      })]
    })]
  });
}
export var DesktopRating = /*#__PURE__*/React.memo(DesktopRatingComponent);